var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCityXs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.30884 14.6899C1.30884 14.4137 1.5327 14.1899 1.80884 14.1899H15.1422C15.4183 14.1899 15.6422 14.4137 15.6422 14.6899C15.6422 14.966 15.4183 15.1899 15.1422 15.1899H1.80884C1.5327 15.1899 1.30884 14.966 1.30884 14.6899Z",
    fill: "#2D2943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.80884 9.85653C3.71679 9.85653 3.64217 9.93115 3.64217 10.0232V14.0232C3.64217 14.1152 3.71679 14.1899 3.80884 14.1899H5.14217C5.23422 14.1899 5.30884 14.1152 5.30884 14.0232V10.0232C5.30884 9.93115 5.23422 9.85653 5.14217 9.85653H3.80884ZM2.64217 10.0232C2.64217 9.37886 3.16451 8.85653 3.80884 8.85653H5.14217C5.7865 8.85653 6.30884 9.37886 6.30884 10.0232V14.0232C6.30884 14.6675 5.7865 15.1899 5.14217 15.1899H3.80884C3.16451 15.1899 2.64217 14.6675 2.64217 14.0232V10.0232Z",
    fill: "#2D2943"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9755 12.0232C3.9755 11.7471 4.19936 11.5232 4.4755 11.5232H4.80884C5.08498 11.5232 5.30884 11.7471 5.30884 12.0232C5.30884 12.2993 5.08498 12.5232 4.80884 12.5232H4.4755C4.19936 12.5232 3.9755 12.2993 3.9755 12.0232Z",
    fill: "#2D2943"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4755 2.52319C6.38346 2.52319 6.30884 2.59781 6.30884 2.68986V14.0232C6.30884 14.1152 6.38346 14.1899 6.4755 14.1899H13.1422C13.2342 14.1899 13.3088 14.1152 13.3088 14.0232V2.68986C13.3088 2.59781 13.2342 2.52319 13.1422 2.52319H6.4755ZM5.30884 2.68986C5.30884 2.04553 5.83117 1.52319 6.4755 1.52319H13.1422C13.7865 1.52319 14.3088 2.04553 14.3088 2.68986V14.0232C14.3088 14.6675 13.7865 15.1899 13.1422 15.1899H6.4755C5.83117 15.1899 5.30884 14.6675 5.30884 14.0232V2.68986Z",
    fill: "#2D2943"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14217 4.02319H7.80884V5.35653H9.14217V4.02319Z",
    fill: "#2D2943"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8088 4.02319H10.4755V5.35653H11.8088V4.02319Z",
    fill: "#2D2943"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14217 6.35653H7.80884V7.68986H9.14217V6.35653Z",
    fill: "#2D2943"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8088 6.35653H10.4755V7.68986H11.8088V6.35653Z",
    fill: "#2D2943"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8088 8.68986H10.4755V10.0232H11.8088V8.68986Z",
    fill: "#2D2943"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8088 11.0232H10.4755V12.3565H11.8088V11.0232Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCityXs);
export default __webpack_public_path__ + "static/media/city-xs.6fc999bf.svg";
export { ForwardRef as ReactComponent };